import { render } from "./OPTALINE Factory.vue?vue&type=template&id=78aa492f&scoped=true"
const script = {}

import "./OPTALINE Factory.vue?vue&type=style&index=0&id=78aa492f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78aa492f"

export default script